import type { FC, ChangeEventHandler, FocusEventHandler } from 'react';

import searchBar from 'public/search-bar.svg';

import { SearchBarContainer, SearchInput, StyledSVG } from './styles';

interface SearchBarProps {
  className?: string;
  handleChange: ChangeEventHandler<HTMLInputElement>;
  handleBlur?: FocusEventHandler<HTMLInputElement>;
}

export const SearchBar: FC<SearchBarProps> = ({ className, handleBlur, handleChange }) => {
  return (
    <SearchBarContainer role="search" className={className}>
      <StyledSVG src={searchBar} />
      <SearchInput
        id="search"
        name="search"
        type="search"
        placeholder="Search"
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </SearchBarContainer>
  );
};
